import React, { useState } from 'react';
import { Select,Switch } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';


const BitsEditorV2 = ({value, pendingValue, onChange, BitsDef={}, Intls={}}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language === "zh" ? "Chinese" : "English";

    const  bits = [], pendingBits = []
    for (var k in BitsDef) {
        var bitV = 0, pendingBitV = 0;
        var start = BitsDef[k].Bits[0];
        for (var i=start; i<(BitsDef[k].Bits[1]??(start+1)); i++) {
            bitV += ((value >> i)&1) << (i-start);
            pendingBitV += ((pendingValue >> i)&1) << (i-start);
        }
        bits[k] = value == null && value == undefined ? undefined : bitV;
        pendingBits[k] = pendingValue == null && pendingValue == undefined ? undefined : pendingBitV;
    }

    const onBitChange = (index, value) => {
        let v = 0;
        for (var k in bits) {
            var start = BitsDef[k].Bits[0];
            if (k==index) {
                v += (value << start);
            } else {
                v += (bits[k] << start);
            }
        }

        onChange?.(v);
    }

    return (
        <div
            style={{
                display:"flex",
                flexDirection:"column",
            }}
        >
            {BitsDef.map((def, k) => <div
                key={k}
                style={{
                    display:"flex",
                    flexDirection:"row",
                    paddingTop: 1,
                    paddingBottom: 1,
                }}
            >
                <div>{Intls[def.Title+"-"+lang] ?? def.Title}:</div>
                <div style={{marginLeft:4}}>
                    {def.Bits[1] 
                    ?
                        <Select
                            key={k}
                            suffixIcon={pendingBits[k] != null  ? <EditOutlined /> : undefined}
                            value={pendingBits[k] != undefined ? pendingBits[k] : bits[k]}
                            onChange={(value)=>{onBitChange(k, value)}}
                            style={{minWidth: 200}}
                        >
                            {Object.keys(BitsDef[k].Items).map((kk) => <Select.Option 
                                key={kk}
                                value={parseInt(kk, 10)}
                            >{Intls[BitsDef[k].Items[kk]+"-"+lang] ?? BitsDef[k].Items[kk]}</Select.Option>)}
                        </Select>
                    :
                        <>
                            <Switch 
                                key={k}
                                checked={pendingBits[k] != undefined ? pendingBits[k] : bits[k]}
                                onChange={(value)=>{onBitChange(k, value)}}
                            />
                            {pendingBits[k] != undefined ? <EditOutlined /> : undefined}
                        </>
                    }
                    
                </div>
            </div>)}
        </div>
    );
};

export default BitsEditorV2;